// extracted by mini-css-extract-plugin
export default {"ranking-boxes":"RankingHomeMain_ranking-boxes__doT0x","ranking-box":"RankingHomeMain_ranking-box__whVO8"};